import Header from "../../components/Header/Header";
import iconTelWhite from "../../assets/icon_tel_wh.svg";
import { Accordion, AccordionItem } from "@szhsin/react-accordion";
import imgTicketPrice from "../../assets/landers_ticket_price.png";
import imgTicketDiscount from "../../assets/landers_ticket_discount.png";
import useReactGASend from "../../hooks/useReactGASend";
import { GiCheckMark } from "react-icons/gi";
import React from "react";


const ssgCustomerCenterButton = {
  title: "SSG.COM 고객센터",
  link: "tel:1577-3419",
  isPhoneLink: true,
};

const introText = `SSG랜더스 APP, SSG.COM APP, SSG.COM 홈페이지를 통해 홈경기 티켓 예매가 가능합니다.
*온라인 예매 매진 시 현장 판매는 미운영 될 수 있습니다.
티켓 관련 일반 문의는 SSG.COM 고객센터(1577-3419)로 문의 부탁드립니다.`;

const common = [
  {
    title: "온라인 예매처 및 예매일정",
    content:
      "1. 온라인 티켓 예매처 : SSG랜더스 APP, SSG.COM APP, SSG.COM 홈페이지\n\n2. 온라인 티켓 예매 오픈 시간 : 예매처와 회원 등급에 따라 상이합니다.\n[SSG랜더스 APP 내 예매 오픈 시간]\n- 랜디, 배티 회원 : 경기 7일 전 오전 11시\n- 푸리 회원 : 경기 6일 전 오전 11시\n- 프렌즈 회원 : 경기 5일 전 오전 11시\n※ 멤버십 선예매는 랜더스 APP을 통해서만 이용 가능하며 통합 회원 가입 필수입니다.\n\n[SSG.COM 내 예매 오픈 시간] : 경기 4일 전 오전 11시\n\n3. 온라인 티켓 예매 마감 시간 : 경기 시작 1시간 후까지 예매 가능합니다.\n\n※ 티켓 예매 관련 자세한 사항은 SSG.COM 고객센터(1577-3419)로 문의 부탁드립니다.",
    buttons: [
      {
        title: "SSG랜더스 APP 바로가기",
        link: "https://www.ssglanders.com/deepLink/home",
      },
      {
        title: "SSG.COM 바로가기",
        link: "https://ticket.ssg.com/ticket?app_banrId=2003889761",
      },
    ],
  },
  {
    title: "현장 구매 방법 및 일정",
    content:
      "인천SSG랜더스필드 매표소에서 당일 경기 티켓 구매 가능합니다.\n\n[매표소 운영 시간]\n- 주중(월~목) : 경기 시작 2시간 30분 전~6회 말 종료 시\n- 주말(금~일 및 공휴일) : 경기 시작 3시간 전~6회 말 종료 시\n\n경기당일 1루/3루/외야/내야 매표소 중 가까운 매표소를 방문하여 구매가능합니다.\n*온라인 예매 매진 시 현장 판매는 미운영 될 수 있습니다.\n\n[매표소 운영 시간]\n- 주중(월~목) : 경기 시작 2시간 30분 전~6회 말 종료 시\n- 주말(금~일 및 공휴일) : 경기 시작 3시간 전~6회 말 종료 시\n- 무인발권기는 매표소 오픈 시간보다 30분 먼저 오픈 됩니다.\n(주니어 멤버십, 할인 권종 등 무인발권기 이용 불가한 경우, 1루 매표소 조기 운영 창구를 방문해 주세요.)\n\n※ 티켓 현장 구매 관련 자세한 사항은 SSG.COM 고객센터(1577-3419)로 문의 부탁드립니다.",
    buttons: [ssgCustomerCenterButton],
  },
  {
    title: "티켓 가격",
    images: [imgTicketPrice, imgTicketDiscount],
    imageAlt: "티켓 가격 안내",
    content: "아래 링크를 통해 26 시즌 티켓 가격을 확인할 수 있습니다.",
    buttons: [
      {
        title: "티켓 가격 확인하기",
        link: "https://www.ssglanders.com/game/ticket",
      },
    ],
  },
  {
    title: "티켓 취소/환불",
    content:
      "1.예매 취소는 경기 당일 오전 10시까지 가능합니다. 취소 시점에 따라 취소 수수료는 아래와 같이 부과됩니다.\n\n-예매 당일 : 취소 수수료 없음\n-예매 익일 ~ 경기 4일 전  :  티켓 결제 금액의 10%\n-경기 3일 전 ~ 경기 1일 전 : 티켓 결제 금액의 20%\n-경기 당일 ~ 취소 마감(오전 10시) 까지 : 티켓 결제 금액의 50%\n※경기 당일 오전 10시 이후 예매건은 취소 불가\n※예매 수수료는 예매 당일 이후 환불 불가\n\n2. 부분 취소 가능하나, 일부 결제수단은 부분 취소가 제한될 수 있습니다\n- 휴대폰 결제, 신세계포인트 복합결제 등\n\n3. 경기일자, 좌석 등급, 권종, 결제수단 변경은 불가하며, 기존 예매 건 취소 후 재예매하셔야 합니다.\n- 단, 취소시점에 따라 예매 수수료가 환불되지 않거나, 취소 수수료가 부과될 수 있습니다. 또한 기존 동일 좌석으로 재예매가 불가할 수 있습니다.\n\n4. 경기 취소 시 티켓은 취소 수수료 부과 없이 자동으로 취소되며, 결제 수단별 환불 방법은 아래와 같습니다.\n- 온라인 예매 건, 현장 매표소에서 신용카드로 구매한 건 : 현장 매표소 방문 필요 없이 자동 환불됩니다. 영업일 기준 3~5일 소요될 수 있습니다.\n- 현장 매표소에서 현금으로 구매한 건 : 경기 취소 후 1시간 이내 1루 매표소 방문(당일 티켓 소지 필수) 및 티켓 반환 후 환불 접수\n\n5. 티켓 예매 시 할인 쿠폰을 사용한 경우, 티켓 취소와 함께 쿠폰은 정상 복원됩니다. 복원된 이후 예매 사이트에서 사용 가능합니다.\n\n※ 티켓 환불 관련 자세한 사항은 SSG.COM 고객센터(1577-3419)로 문의 부탁드립니다.",
    buttons: [ssgCustomerCenterButton],
  },
  {
    title: "온라인 예매 티켓 발권",
    content:
      "1.모바일 티켓 이용방법\n\n- 티켓 수령방법을 [모바일티켓]으로 선택했을 경우, 예매 내역에서 모바일 티켓을 확인할 수 있습니다.\n  (입장 QR코드는 경기 시작 4시간 전에 생성됩니다.)\n- 모바일 티켓은 검표하기 전까지 타인에게 공유/회수 가능합니다.\n- 모바일 티켓을 선택했을 경우 매표소에 들르지 않고 게이트로 바로 입장이 가능합니다.\n- 모바일 티켓은 지류티켓으로 발권되지 않습니다.\n\n2.지류 티켓 발권 방법\n\n- 티켓 수령방법을 [현장수령]으로 선택했을 경우, 경기장 내 '키오스크(무인발권기)' 또는 '매표소'에서 지류 티켓을 발권받아 입장 가능합니다.\n- 현장상황에 따라 [현장수령]을 선택했어도, 온라인 [예매내역]에서 1회에 한해  티켓수령방법을 [모바일 티켓]으로 변경하여 지류 티켓 발권 없이 모바일 티켓으로 입장 가능합니다.\n- 무인발권기에서 '생년월일 6자리+예매번호' 혹은 '생년월일 6자리+휴대전화 번호'를 입력한 후 지류 티켓으로 발권 가능합니다. (무인발권기는 1루 매표소, 3루 매표소, 외야 매표소 옆에 설치)\n- 매표소 창구에서 매표원에게 예매번호, 예매자 성명/생년월일을 전달하고, 지류 티켓으로 발권 가능합니다.\n\n3.매표소 오픈 시간 안내\n\n- 주중(월~목) : 경기 시작 2시간 30분 전~6회 말 종료 시\n- 주말(금~일 및 공휴일) : 경기 시작 3시간 전~6회 말 종료 시\n- 무인발권기는 매표소 오픈 시간보다 30분 먼저 오픈 됩니다.\n(주니어 멤버십, 할인 권종 등 무인발권기 이용 불가한 경우, 1루 매표소 조기 운영 창구를 이용해 주시기 바랍니다.)\n\n※ 티켓 관련 자세한 사항은 SSG.COM 고객센터(1577-3419)로 문의 부탁드립니다.",
    buttons: [ssgCustomerCenterButton],
  },
  {
    title: "모바일티켓 전달 방법",
    content:
      "전달하기 : 모바일티켓은 다른 사람(수신자)에게 전달 가능합니다.\n- 수신자의 성명, 연락처를 입력하면 카카오톡 알림톡 또는 LMS로 모바일티켓 URL이 전송됩니다. (해외 전화번호로는 전달 불가)\n- 모바일티켓 전달 후 보낸 사람은 티켓 예매 취소 불가합니다. (돌려받은 이후에 취소 가능)\n\n회수하기 : 전달한 모바일티켓은 수신자가 \"수락\"하기 전까지 회수 가능합니다.\n\n수락하기 : 수신자는 모바일티켓을 수락하여 모바일티켓 확인이 가능합니다.\n- 카카오톡 알림톡 하단의 \"모바일티켓 보기\" 클릭 후, 공유된 티켓을 수락하면 모바일티켓 확인 가능합니다\n\n돌려주기 : 수신자는 전달받은 모바일티켓을 보낸 사람에게 되돌려 줄 수 있습니다.\n\n※ 티켓 관련 자세한 사항은 SSG.COM 고객센터(1577-3419)로 문의 부탁드립니다.",
    buttons: [ssgCustomerCenterButton],
  },
  {
    title: "경기당 최대 예매 가능 수량",
    content:
      "경기당 최대 6매까지 예매가 가능합니다.\n-바비큐존, 외야파티덱 등 다인석의 경우 좌석 수에 맞춰 예매 가능합니다.\n-경기당 1회에 한해서 6매 초과하는 다인석 예매 가능합니다.\n\n※ 티켓 관련 자세한 사항은 SSG.COM 고객센터(1577-3419)로 문의 부탁드립니다.",
    buttons: [ssgCustomerCenterButton],
  },
  {
    title: "휠체어석 이용",
    content:
      "휠체어장애인석은 휠체어를 사용하는 장애인을 위한 좌석입니다.\n경기장에서 휠체어 사용 여부, 복지카드 확인 후 발권이 가능합니다.\n(모바일티켓이용 불가)\n※ 보호자(1인)는 온라인 예매 후 현장 매표소에서 확인 절차를 진행한 뒤 함께 입장할 수 있습니다.\n(휠체어석 옆 좌석 선택 가능)\n\n※ 티켓 관련 자세한 사항은 SSG.COM 고객센터(1577-3419)로 문의 부탁드립니다.",
    buttons: [ssgCustomerCenterButton],
  },
  {
    title: "통합회원 가입 방법",
    content:
      "SSG랜더스 APP 메인 화면 내 \"SSG.COM 통합회원 바로가기\" 배너를 클릭하여 가입 진행 가능합니다.\n통합 회원 여부는 SSG랜더스 APP > MY페이지 내 '통합회원' 표기로 확인 가능합니다.\nSSG.COM-SSG랜더스 통합 회원 계정으로 SSG.COM 로그인은 어려우며, 기존 SSG.COM 계정 사용 필요합니다.\n\n※ 통합회원 관련 자세한 사항은 SSG.COM 고객센터(1577-3419)로 문의 부탁드립니다.",
    buttons: [
      {
        title: "SSG,COM-SSG랜더스 통합회원 가입안내 바로가기",
        link: "https://app.ssglanders.com/noticeView?seq=3078",
      },
    ],
  },
  // TODO: 확인 필요 - 엑셀 티켓 예매에 없는 기존 항목이라 문구를 유지함. 입장시간·영유아 무료입장은 관람 안내로 옮겨 제외
  // {
  //   title: "단체관람",
  //   content:
  //     "단체관람 제도는 50인 이상의 일반 단체(기업, 동아리 등), 학교 단체(초·중·고교) 대상 일부 좌석에 한 해 운영됩니다. \n\n 단체관람 기준은 SSG랜더스 홈페이지를 참고 부탁드리며, 구매 및 상담은 SSG.COM 고객센터(1577-3419)에서 가능합니다.",
  //   reference: "",
  //   buttons: [
  //     { 
  //       title: "랜더스 홈페이지 바로가기",
  //       link: "https://www.ssglanders.com/game/group"
  //     },
  //     { 
  //       title: "SSG.COM 바로가기",
  //       link: "tel:1577-3419",
  //       isPhoneLink: true,
  //     }
  //   ]
  // },
  // {
  //   title: "다인석 인원추가",
  //   content:
  //     "일부 다인석의 경우 현장 매표소를 통해 관람 인원 추가가 가능합니다. \n\n [ICON:check]가능 좌석 : 내야패밀리존, 외야패밀리존, 오픈바비큐존, 이마트바비큐존, 외야파티덱, 미니 스카이박스, 스카이박스 \n [ICON:check]인원 추가 : 최대 1명 (스카이박스는 최대 2명) \n\n ※ 추가 인원은 현장 매표소를 통해 추가 요금 지불 후 이용 가능합니다. \n※ 별도의 추가 좌석이 제공되지 않는 점 유의 바랍니다. \n※ 가능 좌석 외 일반 좌석은 인원 추가가 불가합니다.",
  //   reference: "",
  // },
  // {
  //   title: "티켓 권종 변경",
  //   content:
  //     "어린이/청소년 할인으로 예매한 티켓은 현장 매표소에서 차액 지불 후 일반 권종으로 변경 가능합니다. \n\n※ 일반 권종 → 어린이/청소년 권종 변경은 불가합니다. \n※ 주니어 멤버십 할인 예매 건은 일반 권종으로 변경 불가합니다.\n※ 어린이/청소년 권종 외 타 할인 권종은 일반 권종 변경이 불가합니다.",
  //   reference: "",
  // },
];

const ICON_MAP = {
  check: <GiCheckMark className="inline-block mr-1"/>
}

const formatText = (text) => {
  return text.split("\n").map((line, index) => {
    const elements = [];

    let rest = line;

    // 1. 앞에 [SPACE]가 몇 개 있는지 계산
    const spaceMatches = rest.match(/^(\[SPACE])+/);
    if (spaceMatches) {
      const count = spaceMatches[0].match(/\[SPACE\]/g).length;
      for (let i = 0; i < count; i++) {
        elements.push(<span key={`space-${i}`} className="pl-2" />);
      }
      rest = rest.replace(/^(\[SPACE\])+/,"").trim();
    }

    // 2. 아이콘 처리
    const iconMatch = rest.match(/\[ICON:(.+?)\]/);
    if (iconMatch) {
      const iconKey = iconMatch[1];
      elements.push(
        <span key="icon" className="inline-flex items-baseline pt-1">
          {ICON_MAP[iconKey]}
        </span>
      );
      rest = rest.replace(iconMatch[0], "").trim();
    }

    // 3. 텍스트
    elements.push(<span key="text">{rest}</span>);

    return (
      <div key={index} className="flex items-start">
        {elements}
        {index < text.split("\n").length - 1 && <br />}
      </div>
    );
  });
};

export const AccordionItemComponent = ({
  item,
  index,
}) => (
  <AccordionItem
    key={index}
    itemKey={index}
    className="mb-2"
    header={({state}) => 
      <div className={`flex items-center w-full pb-2 text-lg font-semibold text-gray-950 border border-[#D1D5DB] p-2.5 bg-white text-left ${state.isEnter ? 'rounded-bl-none rounded-br-none rounded-tl-[30px] rounded-tr-[30px] border-none' : 'rounded-full'}`}>
        <span
          className={`inline-flex items-center justify-center p-3 h-10 bg-black shadow-md rounded-full text-white text-2xl font-semibold shrink-0 mr-2`}
        >
          Q
        </span>
        {item.title}
      </div>
    }
  >
    {({state}) => 
      <div className={`p-6 border rounded-3xl border-[#D1D5DB] bg-white ${state.isEnter && 'rounded-tl-none rounded-tr-none border-none mt-[-10px]'}`}>
        {item.images && item.images.map((image) => (
          <img src={image} alt={item.imageAlt || ""} className="w-full mb-4" />
        ))}
        <p className="font-medium text-gray-950">
          {item.content?.includes("[ICON:") || item.content?.includes("[SPACE]")
            ? formatText(item.content)
            : <span className="whitespace-pre-line">{item.content}</span>}
        </p>
        {item.buttons && (
          <div className="flex justify-center flex-col">
            {item.buttons.map((button) => (
              <LinkItem
                key={button.title}
                title={button.title}
                url={button.link}
                isPhoneLink={button.isPhoneLink}
                styles={"mx-6"}
              />
            ))}
          </div>
        )}
      </div>
    } 
  </AccordionItem>
);


export const LinkButton = ({
  url,
  className,
  imgSrc,
  altText,
  buttonText,
  onClick,
}) => (
  <a
    onClick={onClick}
    href={url}
    className={className}
  >
    <span className="shrink-0">
      <img src={imgSrc} alt={altText} />
    </span>
    <span className="flex-1 text-center">{buttonText}</span>
  </a>
);


export const LinkItem = ({ title, url, isPhoneLink, onClick, styles }) => (
  <li className="pt-4 list-none">
    <a
      onClick={onClick}
      href={url}
      target={isPhoneLink ? undefined : "_blank"}
      rel={isPhoneLink ? undefined : "noopener noreferrer"}
      className={`flex items-center bg-[#FFFFFF] ${
        isPhoneLink ? "gap-4" : ""
      } justify-center min-h-12 h-auto px-4 py-2 text-center text-sm leading-snug rounded-[16px] ${
        isPhoneLink ? "border-2" : "border"
      } border-[#FFA2A2] text-[#CE152D] font-semibold ${styles}`}
    >
      {title}
    </a>
  </li>
);


const TicketPage = () => {
  const { makeEventTrackFn } = useReactGASend();
  const trackButtonClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: title,
    });
  };

  return (
    <section className="p-hasHeader">
      <Header title="티켓 예매" />
      <div className="bg-white p-7 rounded-3xl mb-6 font-medium text-base mt-2 text-gray-950 whitespace-pre-line">
        {introText}
        <LinkItem
          title="SSG.COM 고객센터"
          url="tel:1577-3419"
          isPhoneLink
          onClick={() => trackButtonClick("티켓예매_SSG.COM 고객센터")}
        />
      </div>

      <Accordion transition transitionTimeout={250}>
        {common.map((item, index) => (
          <AccordionItemComponent
            key={index}
            item={item}
            index={index}
          />
        ))}
      </Accordion>

      <div className="flex flex-col items-center mt-10 bg-white p-5 rounded-3xl justify-center w-full ">
        <div className="text-base font-medium text-[#4A5565] pb-2 flex text-center justify-center">추가적인 도움이 필요하신가요?</div>
        <LinkButton
          url="tel:032-455-2600"
          className="flex items-center justify-between w-36 h-9 bg-brand-secondary rounded-[30px] text-white px-6 py-6 text-sm font-medium mb-1.5"
          imgSrc={iconTelWhite}
          buttonText="전화상담"
          onClick={() => trackButtonClick("티켓예매_전화상담")}
        />
      </div>
    </section>
  );
};

export default TicketPage;
